import React from 'react';

import { getClassNames } from '../../../services/stylingUtils';

import styles from './styles.scss';

export default class AlertBox extends React.Component {

    _getClassNames() {
        return getClassNames(styles, this.props.className, {
            'load-more': true
        });
    }

    render() {
        return (
            <button
                onClick={this.props.onClick}
                className={this._getClassNames()}
            >
                { this.props.children }
            </button>
        )
    }
}